<template>
  <div class="d-ib">
    <el-button
        type="primary"
        class="btn-main"
        icon="el-icon-search"
        @click="setDialog(true)"
    >
      Filters
    </el-button>
    <el-dialog
        title="Filters"
        :visible="dialog"
        width="500px"
        top="3vh"
        :modal="true"
        @close="setDialog(false)"
    >
      <el-select
          v-model="label"
          placeholder="Label"
          clearable
          filterable
          class="w100"
      >
        <el-option
            v-for="(r, i) in manual_labels"
            :key="i"
            :label="r.label_name"
            :value="r.label_id"
        ></el-option>
      </el-select>
      <el-input
          placeholder="Video ID"
          clearable
          v-model="video_id"
          class="mt10 w100">
      </el-input>
      <el-select
          v-model="claim_status"
          placeholder="Claim status"
          clearable
          filterable
          class="mt10 w100"
      >
        <el-option value="manual" label="Manual"></el-option>
        <el-option value="auto" label="Auto"></el-option>
        <el-option value="no" label="No Claim"></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      label: '',
      video_id: '',
      claim_status:''
    }
  },
  computed: {
    ...mapState('channelVideoClaims', ['dialog', 'manual_labels'])
  },
  methods: {
    ...mapMutations('channelVideoClaims', ['setDialog', 'setManualFilter']),
    ...mapActions('channelVideoClaims', ['readManualClaims']),

    filter() {
      this.setManualFilter({
        label_id: this.label,
        video_id: this.video_id,
        claim_status: this.claim_status
      })
      this.readManualClaims()
      this.setDialog(false)
    },

    clear() {
      this.setManualFilter({})
      this.readManualClaims()
      this.label = ''
      this.video_id = ''
      this.claim_status = ''
      this.setDialog(false)
    }
  }
}
</script>
